import React, { createContext, useContext } from "react";

const DocsNavigationContext = createContext({
    closeNav: () => {},
    isCompact: false,
    navOpen: true,
    sessionControls: null,
    toggleNav: () => {},
});

export const DocsNavigationProvider = ({ children, value }) => (
    <DocsNavigationContext.Provider value={value}>{children}</DocsNavigationContext.Provider>
);

export const useDocsNavigation = () => useContext(DocsNavigationContext);
